'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dAccount$002dUsers$002dPage from "./presto.-List-Account-Users-Page.js";
var $p;
/** @constructor */
function $c_Lpresto_ListAccountUsersPage$() {
}
export { $c_Lpresto_ListAccountUsersPage$ as $c_Lpresto_ListAccountUsersPage$ };
$p = $c_Lpresto_ListAccountUsersPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListAccountUsersPage$;
/** @constructor */
function $h_Lpresto_ListAccountUsersPage$() {
}
export { $h_Lpresto_ListAccountUsersPage$ as $h_Lpresto_ListAccountUsersPage$ };
$h_Lpresto_ListAccountUsersPage$.prototype = $p;
$p.l = (function() {
  return "ListAccountUsersPage";
});
$p.cH6 = (function(x$0) {
  return new $j_presto$002e$002dList$002dAccount$002dUsers$002dPage.$c_Lpresto_ListAccountUsersPage($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1));
});
var $d_Lpresto_ListAccountUsersPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListAccountUsersPage$, "presto.ListAccountUsersPage$", ({
  KM: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_ListAccountUsersPage$ as $d_Lpresto_ListAccountUsersPage$ };
var $n_Lpresto_ListAccountUsersPage$;
function $m_Lpresto_ListAccountUsersPage$() {
  if ((!$n_Lpresto_ListAccountUsersPage$)) {
    $n_Lpresto_ListAccountUsersPage$ = new $c_Lpresto_ListAccountUsersPage$();
  }
  return $n_Lpresto_ListAccountUsersPage$;
}
export { $m_Lpresto_ListAccountUsersPage$ as $m_Lpresto_ListAccountUsersPage$ };
//# sourceMappingURL=presto.-List-Account-Users-Page$.js.map
